interface IAttentionIconProps {
  exclamationColor?: string;
  triangleOutlineColor?: string;
  className?: string;
}

const AttentionIcon: React.FC<IAttentionIconProps> = ({
  exclamationColor,
  triangleOutlineColor,
  className,
}) => (
  <svg
    width="61"
    height="62"
    viewBox="0 0 61 62"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <g fill="none" fillRule="evenodd">
      <path
        d="m30.56 5.855 30.12 50.2H.44l30.12-50.2zm0 9.751L9.303 51.036h42.512L30.56 15.605z"
        style={{ fill: exclamationColor || 'var(--tt-dark-purple)' }}
        fillRule="nonzero"
      />
      <path
        style={{ fill: triangleOutlineColor || 'var(--tt-yellow)' }}
        d="M28.05 25.935h5.02v15.06h-5.02zM28.05 48.525h5.02v-5.02h-5.02z"
      />
    </g>
  </svg>
);

export default AttentionIcon;
